import React, { useState } from "react";
export default function BiosensorDegradationDesign() {
  const [isBiosensor, setIsBiosensor] = useState(true);

  const switchPage = () => {
    setIsBiosensor(!isBiosensor);
  };

  if (isBiosensor) {
    /*RETURNS biosensor page*/
    return (
        <div
            style={{
              background: "rgb(175,234,255) linear-gradient(180deg, rgba(175,234,255,1) 0%, rgba(87,174,255,1) 47%, rgba(40,57,255,1) 100%)",
              minHeight: "100vh",
            }}
        >
          <div
              className="fixed bottom-0 w-full py-8 px-4 flex justify-around text-2xl text-white cano"
              style={{ backgroundColor: "rgba(87,174,255,.7)" }}
          >
            <a href="#detection_and_quantification">Overview</a>
            <a href="#biological_receptor">Biologicar Receptor hERa</a>
            <a href="#immobilization_title">Immobilization</a>
            <a href="#software_title">Software</a>
            <a href="#3d_printed_title">3D Printed Case</a>
          </div>
          <div className="hero">
            <img
                src="https://static.igem.wiki/teams/4260/wiki/engineering/moneda-biosensor.png"
                alt="Biosensor coin"
                className="w-full"
            />
            <div className="w-full flex justify-around items-center">
              <div onClick={() => switchPage()} className="p-8 clickable">
                <svg
                    width="76.7"
                    height="135.2"
                    viewBox="0 0 59 104"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M55 4L7 52L55 100" stroke="#233876" stroke-width="9" />
                </svg>
              </div>

              <div className="flex flex-col items-center">
                <h2 className="text-3xl cano text-blue-900"> ENGINEERING </h2>
                <h1 className="text-8xl cano text-blue-900"> BIOSENSOR</h1>
              </div>
              <div onClick={() => switchPage()} className="p-8 clickable">
                <svg
                    width="76.7"
                    height="135.2"
                    viewBox="0 0 59 104"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M4 100L52 52L4 4" stroke="#233876" stroke-width="9" />
                </svg>
              </div>
            </div>
          </div>
          <div className="h-full w-full">
            <div className="p-10 max-w-5xl m-auto pt-20 text-white">
              <h1 className="text-6xl text-center text-white font-bold">
                Design - Biosensor
              </h1>
              <br></br>
              <h1
                  id="detection_and_quantification"
                  className="text-3xl text-center text-white text-bold"
              >
                Detection and quantification using a biosensor
              </h1>
              <h1 className="text-2xl text-center text-white ">Overview</h1>

              <p className="p-justify">
                It is important to mention that the implementation plan from
                TecCEM 2021 [1] inspired us to continue with the biosensor. It was
                decided to keep on the fundamental purpose; detect and quantify
                EDCs. But this year Hydro-Defense decided to renovate each
                component and add things that were missing. Drawbacks from TecCEM
                2021 are stated by them.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/engineering-biosensor.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="p-justify">
                TecCEM 2022 designed the whole project according to an evaluation
                and current investigation within the team in order to state our
                purposes, constraints and specifications. Learning from last
                year's advising and adding desirable features to fit the needs of
                our stakeholders, this gave rise to developing{" "}
                <strong>
                  Hydro-Defense: defending crops against disruptors.
                </strong>
              </p>
              <br></br>
              <hr></hr>

              <br></br>
              <br></br>
              <h1 className="text-2xl text-center text-white">
                What is a biosensor?
              </h1>
              <div className="flex">
                <div className="flex flex-1 flex-col max-w-lg">
                  <img
                      src="https://static.igem.wiki/teams/4260/wiki/assets-varios-project/gifcito2.gif"
                      alt="Fig1-sp"
                      width="500"
                      className="figure"
                      align="center"
                  />
                  <p className="figure_desc text-right">
                    <strong>Figure 1.</strong>
                    <em> Parts composing an electrochemical biosensor</em>
                    <br></br>
                  </p>
                </div>
                <div className="flex-1">
                  <p className="p-justify">
                    A biosensor is a device which integrates three elemental
                    parts. The first being a biological recognition element that
                    can be a biocatalyst or bioligands (enzymes, receptor
                    proteins, DNA, aptamers or antibodies), the second; a
                    transducer which can be optical, thermal or electrochemical
                    and the third one the signal processor. A fourth element can
                    be added as a signal amplifier for example. There are many
                    types of biosensors such as colorimetric, electrochemical and
                    piezoelectric.<br></br>
                    Biosensors are tools that estimate a biological or chemical
                    reaction, producing a signal that is proportional to the
                    analyte concentration sensed in the reaction. This tool is a
                    helpful device on medical, regulatory and quality processes
                    [2].
                  </p>
                </div>
              </div>
              <br></br>
              <h1 className="text-2xl text-left text-white">
                Why seek a quantification method?
              </h1>
              <label htmlFor="desplegable1" className="underline text-blue-400">
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/molecula1.png"
                    alt="desplegable1"
                    width="300"
                    align="left"
                />
              </label>
              <br></br>
              <p className="p-justify">
                “In Mexico there is little information on the concentration levels
                of these compounds, due to the lack of public policies aimed at
                providing resources to institutions and researchers trainedto
                carry out this type of study.” [3]<br></br>
                <br></br>
                Ineffective strategies and policies applied to regulation of
                quality and management of water treatment [3].<br></br> <br></br>
                All over the world, only certain countries have regulations within
                EDCs, for example; BPA control is active in the national drinking
                water standards in Europe, USA and Japan, Nonylphenol and
                Estradiol in Japan, phthalates in China, Japan, and the USA [4].
                <br></br>
                <br></br>
              </p>

              <h1 className="text-2xl text-left text-white">
                Other EDCs quantification methods
              </h1>
              <p className="p-justify">
                Methods based on liquid or gas chromatography are efficient for
                the quantification of BPA in biological samples, and have the
                disadvantage of accessibility. Plus, these methods are complicated
                and require expensive equipment with professional personnel. One
                of the interviewed experts added that “if you send the samples to
                be quantified, it also comes with a high cost. At least here in
                Mexico it is quite expensive and not very specific for so many
                EDCs.” (E. Estrada, personal interview, September 12th, 2022)
              </p>
              <p className="p-justify">
                It is then, when the development of cheap, efficient and simple in
                situ methods (such as biosensors) become relevant compared to
                other detection techniques such as high performance liquid
                chromatography (HPLC), liquid chromatography coupled to mass
                spectrometry (LC-MS) , liquid chromatography coupled with
                electrochemical detection (LC-ED), and capillary electrophoresis
                (CE), among others [5]<br></br>
                <br></br>
              </p>
              <br></br>
              <hr></hr>
              <br></br>
              <h1
                  id="the_dbtl_cycle"
                  className="text-4xl text-left text-white font-bold"
              >
                The engineering success: The DBTL cycle
              </h1>
              <p className="p-justify">
                In the building stage of the whole system is created
                simultaneously by different components, each component has its own
                building and testing strategies prior to the assembly of them.
                When all the paths join, the purified protein needs to be ready
                for immobilization on the QCM surface and start assembling the
                hardware.<br></br>
                <br></br>Iteration of each component of the DBTL cycle modifies
                functionality, enhances features and mold design to our
                specifications, but time is consumed. The ideal design is for the
                user to keep the case and software elements for a long period of
                time only changing the consumables that would be the QCM with the
                immobilized protein.
              </p>
              <br></br>

              <h1 className="text-2xl text-center text-white font-bold ">
                Our project: Biosensor Hydro-Defense
              </h1>
              <div className="flex">
                <div className="flex flex-1 flex-col max-w-lg">
                  <img
                      src="https://static.igem.wiki/teams/4260/wiki/biosensorv2.png"
                      alt="Figure3"
                      width="400"
                      className="figure"
                      align="center"
                  />
                </div>
                <div className="flex-1">
                  <p className="p-justify text-justify">
                    <br></br>
                    <br></br>It would be scarcely possible to get rid of EDCs if
                    not quantifying them with anticipation. A reliable,
                    easy-to-use and specific detection method of EDCs is of great
                    significance. It´s desired implementation would be on water
                    samples, mainly the one used in agricultural irrigation
                    systems.
                  </p>
                </div>
              </div>

              <h1 className="text-2xl text-center text-white font-bold">
                iGEM Engineering Cycle
              </h1>
              <div className="flex">
                <div className="flex flex-1 flex-col max-w-lg">
                  <img
                      src="https://static.igem.wiki/teams/4260/wiki/assets-varios-project/cycle-bio.png"
                      alt="Figura5"
                      width="500"
                      className="figure"
                      align="right"
                  />
                </div>
                <div className="flex-1">
                  <p className="p-justify text-justify" text-left>
                    <br></br>The team is composed of different areas;
                    biotechnology (production of recombinant protein),
                    nanotechnology (immobilization), mechatronics, systems
                    (software) and mechanical engineering (3D printed case). This
                    integration is considered an important part for generating
                    ideas and proposals according to what each teammate offers,
                    all together went through the first design stage. Afterwards,
                    each area created a strategy to follow the building stage.
                  </p>
                </div>
              </div>
              <div>
                {" "}
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/pesta-as-parts1.png "
                    alt="Figura5"
                    width="800"
                    className="figure"
                    align="center"
                />
              </div>

              <div>
                <h1 className="text-2xl text-left text-white font-bold">
                  Overall design
                </h1>
                <br></br>
                <p>
                  To achieve success and to ensure that the final product is fit
                  for purpose, the team went through the first stage defining
                  concepts and elements in order to establish the route that will
                  be followed.
                </p>

                <div>
                  <img
                      src="https://static.igem.wiki/teams/4260/wiki/engineering-tab1-overall.png"
                      alt="partnership"
                      className="figure"
                      style={{ width: 1000 }}
                  />
                </div>
                <p>
                  <strong>Specifications</strong>
                  <em>That product must achieve</em>
                </p>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/safety-project/green-scrawl-back-to-school-class-presentation.png"
                    alt="Fig1-sp"
                    width="800"
                    className="figure"
                    align="center"
                />
              </div>

              <br></br>
              <hr></hr>
              <br></br>
              <h1 className="text-2xl text-left text-white">New approach</h1>
              <p className="p-justify">
                The biosensor project of TecCEM 2022´s aim is to address EDCs
                concerning effects through regulatory and normativity frames,
                enhancing water sanitation offering an easy to use in situ tool.
                An electrochemical biosensor capable of quantifying the amount of
                EDCs in crop irrigation water samples. Using Human Estrogen
                Receptor Alpha protein as a biological recognition element
                immobilized on gold nanoparticles used as amplifiers, and an
                aptasensor based on Quartz Crystal Microbalance, a balance for
                very small masses, as the transducer for the signal to be shown in
                our own developed software, and finally all assembled integrating
                our hardware.
              </p>
              <div></div>

              <br></br>
              <h1
                  id="biological_receptor"
                  className="mb-5 text-3xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Recombinant hERα_HD22 protein as biological recognition element.
              </h1>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/gifcito.gif"
                  alt="Fig1-sp"
                  width="300"
                  className="figure"
                  align="center"
              />
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/engineering-tab2-design.png"
                  alt="Fig1-sp"
                  width="900"
                  className="figure"
                  align="center"
              />

              <img
                  src="https://static.igem.wiki/teams/4260/wiki/inteins-naranja.png"
                  alt="Fig1-sp"
                  width="30"
                  className="figure"
                  align="center"
              />
              <p>
                Gif. Verification step only for the protein receptor in the
                overall of the biosensor. Intein RecA mediated ESR1 - construct of
                our own. See parts.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/engineering-tabbuild.png"
                  alt="Fig1-sp"
                  width="900"
                  className="figure"
                  align="center"
              />
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/engineering-tabtest.png"
                  alt="Fig1-sp"
                  width="900"
                  className="figure"
                  align="center"
              />

              <img
                  src="https://static.igem.wiki/teams/4260/wiki/engineering-tab5learn.png"
                  alt="Fig1-sp"
                  width="800"
                  className="figure"
                  align="center"
              />
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/flecha1.png"
                  alt="Fig1-sp"
                  width="30"
                  className="figure"
                  align="center"
              />

              <h1
                  id="immobilization_title"
                  className="mb-5 text-3xl font-bold text-center"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Immobilization
              </h1>
              <p className="p-justify">
                <font color="white">
                  <center>
                    Immobilization on chitosan and in turn in gold nanoparticles
                    on a Quartz Crystal Microbalance (QCM) surface.
                  </center>
                </font>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/project-bio-chitosan.png"
                  alt="Fig1-sp"
                  className="figure"
                  width="300"
              />
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/asset2.png"
                  alt="Fig1-sp"
                  className="figure"
                  width="50"
              />

              <img
                  src="https://static.igem.wiki/teams/4260/wiki/engineering-tab7.png"
                  alt="Fig1-sp"
                  className="figure"
                  width="900"
              />
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/tecem-design-biosensorlearn-tabla-7.png"
                  alt="Fig1-sp"
                  className="figure"
                  width="700"
              />
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/flecha1.png"
                  alt="Fig1-sp"
                  className="figure"
                  algin="center"
                  width="80"
              />

              <h1
                  id="software_title"
                  className="mb-5 text-3xl font-bold text-center"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Software
              </h1>
              <p className="p-justify">
                <font color="white">
                  <center>
                    Where the QCM transduce the detection signal all the way
                    through a laptop
                  </center>
                </font>

                <img
                    src="https://static.igem.wiki/teams/4260/wiki/software1.png"
                    alt="Fig1-sp"
                    className="figure"
                    width="500"
                />
                <br></br>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/teccem-desing-biosensorbuild-tabla-8.png"
                    alt="Fig1-sp"
                    className="figure"
                    width="700"
                />
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/teccem-test-tabla9-1.png"
                    alt="Fig1-sp"
                    className="figure"
                    width="700"
                />
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/teccem-learn-tabla10.png"
                    alt="Fig1-sp"
                    className="figure"
                    width="700"
                />
              </p>

              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/flecha1.png"
                  alt="Fig1-sp"
                  className="figure"
                  align="center"
                  width="80"
              />

              <h1
                  id="3d_printed_title"
                  className="mb-5 text-3xl font-bold text-center"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                3D Printed case
              </h1>
              <p className="p-justify">
                <font color="white">
                  <center>Where assembly will take part</center>
                </font>
              </p>

              <div className="flex">
                <div className="flex flex-1 flex-col max-w-lg">
                  <img
                      src="https://static.igem.wiki/teams/4260/wiki/cajita-qcm.png"
                      alt="Fig1-sp"
                      width="900"
                      className="figure"
                      align="right"
                  />
                </div>
                <div className="flex-1">
                  <img
                      src="https://static.igem.wiki/teams/4260/wiki/biosensorv2.png"
                      alt="Fig1-sp"
                      width="600"
                      className="figure"
                      align="right"
                  />
                </div>
              </div>

              <div>
                <img
                    src=" https://static.igem.wiki/teams/4260/wiki/teccem-desing-build-tabla11.png"
                    alt="Fig1-sp"
                    width="900"
                    className="figure"
                    align="right"
                />{" "}
              </div>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/test-tabla12.png"
                  alt="Fig1-sp"
                  className="figure"
                  width="700"
              />
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/learn-tabla13.png"
                  alt="Fig1-sp"
                  className="figure"
                  width="700"
              />

              <hr></hr>
              <h1
                  className="mb-5 text-3xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                References
              </h1>
              <p className="reference">
                [1] iGEM TecCEM 2021https://2021.igem.org/Team:TecCEM
              </p>
              <br></br>
              <p className="reference">
                [2] Diezma, B. y Correa, E. (2018). Biosensores y sistemas ópticos
                y de visión avanzados: su aplicación en la evaluación de la
                calidad de productos IV gama. Agrociencia Uruguay, 22(1).
                https://doi.org/10.31285/agro.22.1.2
              </p>
              <br></br>
              <p className="reference">
                [3] Ronderos-Lara, J. G., Saldarriaga-Noreña, H., Reyes-Romero, P.
                G., Chávez-Almazán, L. A., Vergara-Sánchez, J., Murillo-Tovar, M.
                A., & Torres-Segundo, C. (2020, 12 1). Emerging Compounds in
                Mexico: Challenges for Their Identification and Elimination in
                Wastewater. IntechOpen. DOI: 10.5772/intechopen.93909
              </p>
              <br></br>
              <p className="reference">
                [4] Pironti, C., Ricciardi, M., Proto, A., Bianco, P. M., Montano,
                L., & Motta, O. (2021, 05 11). Endocrine-Disrupting Compounds: An
                Overview on Their Occurrence in the Aquatic Environment and Human
                Exposure. MDPI. https://doi.org/10.3390/w13101347
              </p>
              <br></br>
              <p className="reference">
                [5] Scognamiglio, V., Pezzotti, I., Pezzotti, G., Cano, J.,
                Manfredonia, I., Buonasera, K., Arduini, F., Moscone, D.,
                Palleschi, G., & Giardi, M. T. (2012). Towards an integrated
                biosensor array for simultaneous and rapid multi-analysis of
                endocrine disrupting chemicals. Analytica chimica acta, 751,
                161–170. https://doi.org/10.1016/j.aca.2012.09.010
              </p>
              <br></br>
              <p className="reference">
                [6] Rivera-Jaimes, J. A., Postigo, C., Melgoza-Alemán, R. M.,
                Aceña, J., Barceló, D., & López de Alda, M. (2018). Study of
                pharmaceuticals in surface and wastewater from Cuernavaca,
                Morelos, Mexico: Occurrence and environmental risk assessment.
                Science of The Total Environment, 613-614, 1263–1274.
                doi:10.1016/j.scitotenv.2017.09.134
                10.1016/j.scitotenv.2017.09.134
              </p>
              <br></br>
              <p className="reference">
                [7] Gilles Flouriot, Caroline Griffin, Maryrose Kenealy, Vera
                Sonntag-Buck, Frank Gannon, Differentially Expressed Messenger RNA
                Isoforms of the Human Estrogen Receptor-α Gene Are Generated by
                Alternative Splicing and Promoter Usage, Molecular Endocrinology,
                Volume 12, Issue 12, 1 December 1998, Pages 1939–1954,
                https://doi.org/10.1210/mend.12.12.0209
              </p>
              <br></br>
              <p className="reference">
                [8] Gierach, G. L., Ichikawa, L., Kerlikowske, K., Brinton, L. A.,
                Farhat, G. N., Vacek, P. M., Weaver, D. L., Schairer, C., Taplin,
                S. H., & Sherman, M. E. (2012, August 22). Relationship Between
                Mammographic Density and Breast Cancer Death in the Breast Cancer
                Surveillance Consortium. Journal of the National Cancer Institute.
                https://doi.org/10.1093/jnci/djs327
              </p>
              <br></br>
            </div>
          </div>
        </div>
    );
  } else {
    /* RETURNS degradation page*/
    return (
        <div
            style={{
              backgroundColor: " rgb(255,183,233)",
              background:
                  "linear-gradient(180deg, rgba(255,183,233,1) 0%, rgba(255,129,232,1) 47%, rgba(147,0,255,1) 100%)",

              minHeight: "100vh",
            }}
        >
          <div className="hero">
            <img
                src="https://static.igem.wiki/teams/4260/wiki/imagen/project/degradation-model/fondos-de-degradacion/moneda-molecula.png"
                alt="Degradation coin"
                className="w-full"
            />
            <div
                className="fixed bottom-0 text-center w-full py-8 px-4 flex justify-around text-2xl text-white cano"
                style={{ backgroundColor: "rgba(255,129,232,.5)" }}
            >
              <a href="#degradation_title">Engineering</a>
              <a href="#problematic_title">Problematic</a>
              <a href="#solution_title">Solution</a>
              <a href="#dbtl_cycle_title">The DBTL cycle</a>
              <a href="#dbtl_laccase_title">Laccase</a>
              <a href="#immobilization_title"> Immobilization</a>
              <a href="#letucce_experiment_title"> Lettuce experiment</a>
              <a href="#reference_title">References</a>
            </div>
            <div className="w-full flex justify-around items-center">
              <div onClick={() => switchPage()} className="p-8 clickable">
                <svg
                    width="76.7"
                    height="135.2"
                    viewBox="0 0 59 104"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M55 4L7 52L55 100" stroke="#FFF" stroke-width="9" />
                </svg>
              </div>

                <div className="flex flex-col items-center">
                    <h2 className="text-3xl cano text-blue-900"> ENGINEERING </h2>
                    <h1 className="text-8xl cano text-blue-900"> DEGRADATION</h1>
                </div>

              <div onClick={() => switchPage()} className="p-8 clickable">
                <svg
                    width="76.7"
                    height="135.2"
                    viewBox="0 0 59 104"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M4 100L52 52L4 4" stroke="#FFF" stroke-width="9" />
                </svg>
              </div>
            </div>
          </div>
          <div className="h-full w-full">
            <div className="p-10 max-w-6xl m-auto pt-20 text-white">
              <h1 id="degradation_title"className="text-6xl text-center text-white font-bold">
                Design - Degradation
              </h1>
              <h1 className="text-3xl text-center text-blue font-bold font-blue">
                Engineering degradation
              </h1>

              <h1 className="text-2xl text-center text-white ">First approach</h1>
              <div className="flex">
                <div className="flex flex-1 flex-col max-w-lg">
                  <img
                      src="https://static.igem.wiki/teams/4260/wiki/teccem-drawbacksandimprovementsdesing.png"
                      alt="Fig1-sp"
                      width="900"
                      className="figure"
                      align="right"
                  />
                  <p className="figure_desc text-right">
                    <strong>Figure 1.</strong>{" "}
                    <em>Inspiration by iGEM Tec CEM Team 2021.</em>
                    <br></br>
                  </p>
                </div>
                <br></br>
                <div className="flex-1">
                  <p className="p-justify max-w-2xl">
                    <br></br>
                    <br></br>
                    The implementation plan from TecCEM 2021 [1] inspired us to
                    improve the enzymatic degradation system. It was decided to
                    keep on going with the fundamental purpose, degrading
                    Endocrine Disrupting Chemicals (EDCs) into less toxic and less
                    complex compounds. That is how this year, Hydro-Defense,
                    decided to renovate every component and to add things that
                    were missing. Drawbacks from the iGEM TecCEM 2021 team were
                    taken into account and the iGEM Tec CEM 2022 team tried to
                    make some improvements from them (figure 1).
                  </p>
                </div>
              </div>

              <div className="flex">
                <div></div>
              </div>

              <br></br>
              <h1 id="problematic_title"className="text-2xl text-center text-blue font-bold font-blue">
                Problematic
              </h1>

              <p className="p">
                TecCEM 2022 designed the whole project according to an evaluation
                and current investigation within the team in order to state the
                problematic, our purposes, constraints and specifications.
                Learning from last year's advice and adding desirable features to
                fit the needs of our stakeholders, this gave rise to developing
                Hydro-Defense: defending crops against disruptors.
                <img

                    src="https://static.igem.wiki/teams/4260/wiki/teccem-1problemdegra-design.png"
                    alt="partnership"
                    className="figure"
                    style={{ width: 900 }}
                />
              </p>
              <p className="figure_desc">
                <strong>Fig. 2 </strong>
                <em>Explanation of the problematic we are facing.</em>
              </p>
              <br></br>
              <h1 id="solution_title" className="text-2xl text-center text-blue font-bold ">
                Solution
              </h1>

              <p className="p">
                A solution of the problem is proposed by TecCEM 2022, addressing
                EDCs in crop irrigation water. The proposal consists in designing
                and developing a system to degrade endocrine disrupting chemicals
                in order to guarantee EDCs free water for crop irrigation. The
                proposed enzymatic degradation system consists in utilizing
                laccase immobilized in a Zeolitic Imidazole Framework (ZIF) called
                zeolite, to degrade the EDCs (see figure 3).
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/teccem-degra-desing-engi-solution.png"
                  alt="partnership"
                  className="figure"
                  style={{ width: 1000 }}
              />
              <p className="figure_desc">
                <strong>Fig. 3</strong>{" "}
                <em>iGEM TecCEM 2022 Degradation Proposal.</em>
              </p>
              <br></br>
              <br></br>

              <h1 id="dbtl_cycle_title" className="text-3xl text-center text-blue font-bold font-blue">
                The DBTL cycle
              </h1>
              <h1 className="text-2xl text-center text-blue font-bold font-blue">
                Overview
              </h1>
              <label htmlFor="desplegable1" className="underline text-blue-400">
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/cycle.png"
                    alt="desplegable1"
                    width="400"
                    align="left"
                />
              </label>
              <p className="p">
                <br></br>In this part, we explain the degradation system, its main
                experimental procedures, and the Design, Build, Test and Learn
                Cycle in each of the experiments.
              </p>
              <p className="p">
                The principal experiments made by iGEM Tec CEM in this part of the
                project involve: laccase production and purification,
                immobilization of the laccase, and carbamazepine effects in
                lettuces. Each stage of the DBTL cycle was evaluated and assessed
                in these activities (see figures 4, 5 and 6 to learn a general
                overview of these stages).
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/teccem-dabtllacproduction-1.png"
                  alt="partnership"
                  className="figure"
                  style={{ width: 700 }}
              />
              <p className="figure_desc">
                <strong>Fig. 4 </strong>
                <em>DBTL cycle of laccase production and purification.</em>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/teccem-dabtlenzyme-immobilizationlac-1.png"
                  alt="partnership"
                  className="figure"
                  style={{ width: 700 }}
              />
              <p className="figure_desc">
                <strong>Fig. 5 </strong>
                <em>DBTL cycle of the immobilization of the laccase.</em>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/tecem-dabtllettuces.png"
                  alt="partnership"
                  className="figure"
                  style={{ width: 700 }}
              />
              <p className="figure_desc">
                <strong>Fig. 6 </strong>
                <em>DBTL cycle of the experimental of CBZ in lettuces.</em>
              </p>
              <h1 id="dbtl_laccase_title" className="text-3xl text-center text-blue font-bold ">
                DBTL of laccase (Lac_TV_HD22) production and purification.{" "}
              </h1>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/img-3810.png"
                  alt="desplegable1"
                  width="400"
                  align="left"
              />
              <div>
                <h1 className="text-2xl text-center text-blue">Design</h1>
                <p>
                  We chose laccases because they are well known to degrade phenols
                  and aromatic or aliphatic amines with lower redox potential than
                  themselves, and can even oxidize bigger molecules that can’t fit
                  their active site with the help of redox mediators. [7] EDCs
                  fall perfectly in that description, and furthermore, there’s
                  already been research done with the laccase originating from
                  Trametes versicolor and its capabilities of degrading EDCs in
                  wastewater, with elimination rates of 83% of these compounds in
                  the first 6 hours, and 99% after 24 hours [8].
                </p>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/teccem-reactionoflaccase1.png"
                    alt="aadas"
                    className="figure"
                    style={{ width: 700 }}
                />
                <p className="figure_desc">
                  <strong>Fig. 7 </strong>
                  <em>
                    General oxidizing reaction of laccase. Retrieved from [9]
                  </em>
                </p>
              </div>

              <br></br>
              <div>
                <p>
                  The obtention of the laccase is recombinantly using transformed{" "}
                  <em>E.coli</em> BL21 and HMS174 strains with plasmid
                  pJET1.2+BBa_K4260003.
                </p>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/teccem-pjet12blunt-lac-tvhd22-ligacin.jpg"
                    alt="partnership"
                    className="figure"
                    style={{ width: 600 }}
                />
                <p className="figure_desc">
                  <strong>Fig. 8 </strong>
                  <em>Plasmid pJET1.2 ligated with BBa_K4260003.</em>
                </p>
              </div>
              <br></br>
              <p>
                Synthesized LacTV_HD22 mRNA sequence with a periplasmic signal
                peptide OmpA and a histidine tag at the C terminal, flanked by T7
                regulatory expression system and regulated by IPTG induction as
                well. See our in vitro assembly at parts. A histidine tag was
                added at the C-terminal, in order to facilitate protein
                purification via IMAC chromatography. See more at results.
                <br></br>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Build</h1>
                <br></br>
                The <em>in silico</em> protein coding sequence is BBa_K4260003
                (with no scars) and was built in SnapGene, an in-frame sequence
                flanked by regulatory and expression elements. See parts.
                Furthermore, Development of Molecular dockings showed that
                Lac_TV_HD22 interacts with BPA and CBZ in a spontaneous reaction.
                This docking was made with Autodock Vina and visualized in Pymol.
                See results.
                <br></br>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/teccem-tabladecbzconcentrations.png"
                    alt="partnership"
                    className="figure"
                    style={{ width: 600 }}
                />
                <br></br>
                We have also made a ligation of the biobricks in a vector pJET 1.2
                blunt, then transforming in the <em>E.coli</em> DH5 alpha to
                obtain plasmid copies and then transforming the best candidates on{" "}
                <em>E.coli</em> BL21 and HMS174 strains, those bacteria were
                induced with IPTG. These strains were selected because IPTG and
                incubated for 24 hours. The resulting biomass was harvested and
                purification via ionic exchange chromatography (IEC) in order to
                obtain our recombinant protein.
                <br></br>
                <br></br>
              </p>

              <p>
                <h1 className="text-2xl text-center text-blue">Test.</h1>
                <br></br>
                SDS-PAGE was developed to verify in the bands of the gel the
                presence of the protein concentrated in the periplasmic space. The
                experiment conduction was performed with a protocol for periplasm
                protein precipitation, centered in centricons and MgSO4.
                Requirements to determine success involve: SDS-PAGE. The controls
                used for verification: Competent cell without the plasmid. The
                Repeats for an acceptable degree of confidence wew one and the
                results consist in SDS-Page with clear bands at 59 kDa, expected
                size of the protein and the control without an overexpressed
                protein at that size. We will report the data with SDS-Page images
                with controls.
                <br></br>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Learn.</h1>
                <br></br>
                We observed different outcomes so we changed techniques and
                procedures to obtain the expected results. We changed the
                expression vector and expression strain and there was still no
                solid evidence that our laccase was correctly expressed nor
                functional. We suspect that the reason is that competent cells
                were not actually DH5 alpha nor BL21 due to microbiological assays
                in EMB plates, in which the cells did not show the correct
                morphology. With that in mind, we learned that microbiological
                assays should be performed before starting experiments, as well as
                transforming in different expression strains to have a variety in
                the analysis.
                <br></br>
                Expected results were not obtained, therefore the next step in the
                course of action is to assess the identity of the expression
                vector and expression strain, a ligation between construct and
                pET-17b expression vector, hypothesizing that pJET 2.1 being a
                cloning vector (even if our sequence already had promoter,
                terminator and RBS) may be causing struggle in the protein
                production.
                <br></br>
                <br></br>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/hongolacasa.png"
                    alt="aadas"
                    className="figure"
                    style={{ width: 500 }}
                />
              </p>

              <p>
                <h1  id="immobilization_title" className="text-3xl text-center text-blue text-bold">
                  DBTL of Laccase Immobilization
                </h1>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Design.</h1>
                Laccase, like other enzymes, has specific activity parameters
                where certain temperature ranges and pH ranges stand out. With the
                purpose of improving the stability of the laccase under different
                environmental conditions, the reuse cycles and the half-life of
                the protein we seeked to perform an immobilization. First, we
                realized brainstorming and adsorption on porous surfaces came
                back, its encapsulation or its link to nanoparticles. However, the
                most promising option was the creation of an open trapping system,
                where our enzyme is absorbed in a mechanism that allows the
                passage of a sample flow but does not allow the release of the
                compound to the outside.
                <br></br>A material that allows the creation of such a system and
                that has been reported several times [5, 6, 11, 12] as a good
                substrate to interact with enzymes is zeolite. Zeolites are
                minerals composed of aluminum and silicon that are shaped like a
                hollow box that allows fluids to flow through them. They play a
                cage role since they contain the immobilized laccase inside, which
                will be "locked" in the zeolite and will be in direct contact with
                a water sample, thus carrying out the degradation work, avoiding
                unexpected damage to the enzyme. We have also selected zeolite
                because it is being used in pollutant removal because of its
                pollutant adsorption properties [5]
                <br></br>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Build.</h1>
                To carry out the immobilization we rely on the protocol presented
                by [5]. Since it is a process that does not take much time and is
                carried out by means of a single step. From an enzymatic solution,
                a layer of the open trapping system is synthesized around the
                surface of each protein and subsequently washed to eliminate
                residues. To learn more about the protocol performed in the
                experimental phase, please visit the Protocol book tab on page 15.
                The verification of the enzyme will consist of analyzing, by means
                of UV-VIS spectrum, all the supernatants of the experimentals. We
                expect no peak is observed at 280 nm, which is the protein's
                wavelength.
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/interrogacion.png"
                    alt="aadas"
                    className="figure"
                    style={{ width: 100 }}
                />
                <br></br>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Test.</h1>
                <br></br>
                In the verification and testing stage of our system, we carried
                out three different phases where different aspects were analyzed.
                First, size distribution and suspension stability by means of the
                DLS technique. Second, morphology and dry behavior, with the help
                of SEM. Finally, the study of colorimetric enzymatic activity
                assay (with malachite green and guaiacol) and immobilization
                density through spectrophotometric analysis. To determine the
                success of the results, we are expecting to observe enzymatic
                activity in the colorimetric enzymatic activity assays and no
                presence of protein in the washings.
                <br></br>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Learn.</h1>
                <br></br>
                With the results obtained, we concluded that interaction between
                zeolite and laccase is not a strong one, that's why we need to
                increase the interaction strength between our enzyme (Laccase
                TV_H22) and the substrate (zeolite) stands out. This interaction
                can be increased by promoting the formation of different types of
                bonds such as ionic or covalent.<br></br>
                <br></br>For this, the functionalization of the surface of our
                substrate is required, in such a way that it favors the polar
                charges present in the structure of the enzyme [10, 11]. To
                achieve this objective, a dendritic-type structure could be
                generated on the surface of the zeolite, based on what is reported
                in the literature, generating bonds activated with glutaraldehyde
                promotes covalent interactions with laccase [12], which would help
                us to obtain a more stable immobilization before different
                environmental conditions.
                <br></br>
                <br></br>
                <br></br>
                <h1 id="letucce_experiment_title"className="text-4xl text-center text-blue">
                  DBTL Lettuce experimentation
                </h1>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Design</h1>
                <br></br>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/imagen/project/degradation-model/project-degra-lechuga2.png"
                    alt="aadas"
                    className="figure"
                    style={{ minWidth: 250, maxWidth: 250, width: 250 }}
                />
                We decided to do this experiment because EDCs are known to have
                adverse effects on plant’s health when absorbed by the organisms,
                with BPA causing reduction of root length, fresh and dry weight
                between contaminated and healthy plants, and bioaccumulating on
                plant’s roots [13]. CBZ also has toxic effects on growth and fruit
                development, chlorophyll content of leaves, chlorosis, and even
                necrosis [14], that’s why we aimed to develop an experimental
                procedure to test root length and leaf length in lettuces
                irrigated with carbamazepine, to demonstrate that endocrine
                disruptors can also cause damage to plant organisms. The
                acquisition of the material consisted in buying grown lettuce (1
                month old) of the italian variety, obtaining the soil and
                performing our experiments on them. CBZ was procured via
                sponsorships and donations. We choose to irrigate with
                carbamazepine (CBZ) because it has been proven its presence in
                wastewaters that are used to irrigate crops, especially in Tula
                Valley, mexico [C15]
                <br></br>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Build</h1>
                <br></br>
                We decided to irrigate lettuce with CBZ- contaminated water at
                varying concentrations in order to assess the impact that these
                chemicals had on the lettuces. Two CBZ concentrations were
                selected: 45 mg/mL and 4.5 mg/mL, with plants being irrigated for
                8, 15, and 22 days with these contaminants, giving us a total of 6
                treatments which were done in triplicate, one lettuce irrigated
                only with water (negative control) for every treatment (total of
                24 plants). Factorial design looks as follows:
                <br></br>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/teccem-tabladecbzconcentrations.png"
                    alt="aadas"
                    className="figure"
                    style={{ width: 600 }}
                />
                <p>
                  <strong>Fig 9.</strong>
                  <em>
                    Factorial design of irrigation of lettuce with CBZ
                    (experimentation)
                  </em>
                </p>
                <br></br>
                Plants were then harvested and analyzed morphologically, measuring
                root length and leaf length. This data was then analyzed
                statistically to test whether there were any significant
                differences between plants irrigated with high, low and no
                concentration of EDCs in their irrigation water (see results).
                Besides planning the experimental procedure, we needed to
                manufacture a rack to support the lettuces, taking into account:
                sunlight, water quantity, type of soil, nutrients and guarantee
                everything that the lettuce needed in order to obtain reliable
                results. This was achieved by obtaining advice from an agronomist
                engineer called Oscar.
                <br></br>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Test</h1>
                <br></br>
                We measured the root and leaf length of contaminated lettuces with
                CBZ. The objective of the test is to assess and evaluate the
                effects caused by Carbamazepine.
                <br></br>The experiment conduction involved measuring the leaves
                extending them to their maximum length and measuring from the end
                of the leaf’s petiole to its apex. Roots were dried and carefully
                extended to their maximum length, measuring from the first lateral
                root all the way to the end of the last root hair. The
                requirements to determine success (tools) include controlled
                growth conditions (no additional variables other than EDC
                concentration), homogeneous irrigation water (same concentration
                of EDCs each irrigation for the same treatment, no CBZ
                precipitation).
                <br></br>The data format is shown and documented in photographs of
                each measured leaf and root
                <br></br>The controls used for verification were plants irrigated
                only with water and no EDCs, one for each treatment. We also
                applied repeats for an acceptable degree of confidence:
                triplicates for each experimental procedure. The results and data
                be reported and documented in the notebook, including
                concentration, number of experimental, time of exposure and the
                measures of leaf and root, statistical analysis of the obtained
                data (ANOVA, pareto and analysis of surface and contour plots)
                <br></br>
                <br></br>
                <h1 className="text-2xl text-center text-blue">Learn.</h1>
                We did not obtain the results as expected due to experimental
                conditions. We did not grant the necessary sunlight to all the
                lettuces because of permissions and infrastructure, affecting the
                quantity of light the lettuces received. There could also be
                variations on the amounts received of water during irrigation due
                to the design of the containers for the lettuces. To improve the
                experiment for the construction of the rack it must be considered
                the location for receiving sunlight or even implementing
                artificial light sources. Also improvements on the bags that
                contained the soil and the lettuces could be done to homogenize
                each sample.
                <br></br>
                <br></br>
                <img
                    src=" https://static.igem.wiki/teams/4260/wiki/imagen/project/degradation-model/project-degra-igemonito.png"
                    alt="aadas"
                    className="figure"
                    style={{ width: 200 }}
                />
              </p>
              <p>
                <h1 id="reference_title" className="text-3xl text-left text-blue font-bold font-blue">
                  References
                </h1>
                <p className="reference">
                  <br></br>
                  <br></br>[1] Team:TecCEM - 2021.igem.org. (s. f.). Recuperado 11
                  de octubre de 2022, de https://2021.igem.org/Team:TecCEM
                  <br></br>[2] Pridemore, C. M. (2021). The effects of endocrine
                  disrupting chemicals on plants the effects of endocrine
                  disrupting chemicals on plants. Marshall University.
                  https://mds.marshall.edu/cgi/viewcontent.cgi?article=2416&context=etd
                  <br></br>[3] OECD. (2008). OECD Environmental Outlook to 2030.
                  doi:10.1787/9789264040519-en
                  <br></br>[4] United Nations. (2017, 21 junio). World population
                  projected to reach 9.8 billion in 2050, and 11.2 billion in 2100
                  [Comunicado de prensa].
                  https://www.un.org/en/development/desa/population/events/pdf/other/21/21June_FINAL%20PRESS%20RELEASE_WPP17.pdf
                  <br></br>[5] Naseri, M., Pitzalis, F., Carucci, C., Medda, L.,
                  Fotouhi, L., Magner, E., & Salis, A. (2018). Lipase and Laccase
                  Encapsulated on Zeolite Imidazolate Framework: Enzyme Activity
                  and Stability from Voltammetric Measurements. In ChemCatChem
                  (Vol. 10, Issue 23, pp. 5425–5433). Wiley.
                  https://doi.org/10.1002/cctc.201801293
                  <br></br>[6] Zhang, H., Jiang, Z., Xia, Q., & Zhou, D. (2021).
                  Progress and perspective of enzyme immobilization on zeolite
                  crystal materials. In Biochemical Engineering Journal (Vol. 172,
                  p. 108033). Elsevier BV.
                  https://doi.org/10.1016/j.bej.2021.108033
                  <br></br>[7] Viswanath, B., Rajesh, B., Janardhan, A., Kumar, A.
                  P., & Narasimha, G. (2014). Fungal Laccases and Their
                  Applications in Bioremediation. In Enzyme Research (Vol. 2014,
                  pp. 1–21). Hindawi Limited. https://doi.org/10.1155/2014/163242
                  <br></br>[8] Becker, D., Rodriguez-Mozaz, S., Insa, S.,
                  Schoevaart, R., Barceló, D., de Cazes, M., ... & Wagner, M.
                  (2017). Removal of endocrine disrupting chemicals in wastewater
                  by enzymatic treatment with fungal laccases. Organic Process
                  Research & Development, 21(4), 480-491.
                  https://doi.org/10.1021/acs.oprd.6b00361
                  <br></br>[9] Burrows, H. D., Canle L, M., Santaballa, J. A., &
                  Steenken, S. (2002). Reaction pathways and mechanisms of
                  photodegradation of pesticides. In Journal of Photochemistry and
                  Photobiology B: Biology (Vol. 67, Issue 2, pp. 71–108). Elsevier
                  BV. https://doi.org/10.1016/s1011-1344(02)00277-4
                  <br></br>[10] Ramírez, L. et. al. (2022). Improvement in the
                  Thermostability of a Recombinant β-glucosidase Immobilized in
                  Zeolite under Different Conditions. Molecules, 27, 4105.
                  https://doi.org/10.3390/molecules27134105
                  <br></br>[11] Kumari, A. et. al. (2015). Isolation and
                  immobilization of alkaline protease on mesoporous silica and
                  mesoporous ZSM-5 zeolite materials for improved catalytic
                  properties. BBR, 2, 108.
                  http://dx.doi.org/10.1016/j.bbrep.2015.05.009
                  <br></br>[12]Celikbicak, O. et. al. (2014). Immobilization of
                  laccase on hairy polymer grafted zeolite particles: Degradation
                  of a model dye and product analysis with MALDI–ToF-MS.
                  Micromeso, 199, 57.
                  http://dx.doi.org/10.1016/j.micromeso.2014.08.003
                  <br></br>[13] Ferrara, G., Loffredo, E., & Senesi, N. (2006).
                  Phytotoxic, clastogenic and bioaccumulation effects of the
                  environmental endocrine disruptor bisphenol A in various crops
                  grown hydroponically. Planta, 223(5), 910-916.
                  https://doi.org/10.1007/s00425-005-0147-2
                  <br></br>[14] Knight, E. R., Carter, L. J., & McLaughlin, M. J.
                  (2018). Bioaccumulation, uptake, and toxicity of carbamazepine
                  in soil–plant systems. Environmental toxicology and chemistry,
                  37(4), 1122-1130. https://doi.org/10.1002/etc.4053
                  <br></br>[15] Gibson, R., Durán-Álvarez, J. C., Estrada, K. L.,
                  Chávez, A., & Jiménez Cisneros, B. (2010). Accumulation and
                  leaching potential of some pharmaceuticals and potential
                  endocrine disruptors in soils irrigated with wastewater in the
                  Tula Valley, Mexico.
                </p>
              </p>
            </div>
          </div>
        </div>
    );
  }
}